import { ErrorOutline } from '@mui/icons-material';
import React from 'react';

import { COLORS } from '../../../../../configs/colors';
import {
  ErrorCard,
  ErrorCardTitle,
  ErrorCardMessage,
  RetryButton,
} from './ServiceListStates.styles';

interface ServiceListErrorProps {
  onRetry: () => void;
}

export const ServiceListError: React.FC<ServiceListErrorProps> = ({ onRetry }) => (
  <ErrorCard>
    <ErrorOutline sx={{ fontSize: 40, color: COLORS.MediumGrey }} />
    <ErrorCardTitle>Failed to Load Services</ErrorCardTitle>
    <ErrorCardMessage>
      Something went wrong while loading your services. Check your connection and try again.
    </ErrorCardMessage>
    <RetryButton onClick={onRetry}>Try Again</RetryButton>
  </ErrorCard>
);
